import { Edit16 } from 'ui/icons/action/Edit16';
import { SecondaryButton } from 'ui/button';
import { useTranslation } from '../../../hooks/useTranslation';

type CustomTextButtonProps = {
  onSelectContent: (content: string) => void;
};

export const CustomTextButton = ({ onSelectContent }: CustomTextButtonProps) => {
  const { t } = useTranslation();

  const onClick = () => {
    onSelectContent('');
  };

  return (
    <SecondaryButton onClick={onClick} data-test="custom-text-button">
      <Edit16 isColorInherited />
      {t('contentPicker.text')}
    </SecondaryButton>
  );
};
